import { queryOptions, useQuery } from "@tanstack/react-query";
import { TodoVault } from "@/lib/types";
import { useUser } from "@/hooks/useUserProvider";
import { normalizeRequestError } from "@/lib/errors";
import { request } from "@/lib/request";

// Shared key+fn so the boot prefetch (main.tsx) and the hook dedupe.
export const todoVaultsQueryOptions = () =>
  queryOptions({
    queryKey: ["todos", "vaults"] as const,
    queryFn: async (): Promise<TodoVault[]> => {
      const res = await request
        .get("/internal/todos/vaults")
        .catch(
          normalizeRequestError("Something went wrong, please try again."),
        );

      return res.data.data;
    },
  });

export const useGetTodoVaults = () => {
  const { accessToken } = useUser();
  return useQuery({
    ...todoVaultsQueryOptions(),
    enabled: !!accessToken,
  });
};
